export const translations = {
  en: {
    nav: {
      about: 'About',
      services: 'Services',
      skills: 'Skills',
      projects: 'Projects',
      clients: 'Clients',
      hireMe: 'Hire Me',
    },
    hero: {
      available: 'AVAILABLE FOR FREELANCE',
      titleLine1: 'GAMEPLAY',
      titleLine2: 'PROGRAMMER',
      subtitle: 'Crafting immersive game mechanics that',
      subtitleHighlight: 'bend reality',
      description:
        'Freelance gameplay programmer specializing in game feel, systems design, and bringing your vision to life — from prototype to ship-ready.',
      viewWork: 'View My Work',
      getInTouch: 'Get In Touch',
    },
    about: {
      title: 'WHO AM I',
      p1: "Hi, I'm a French gameplay programmer with a Master's degree in Game Development, bringing a strong foundation in creating engaging and interactive experiences.",
      p2: 'With a passion for video games and a love for challenges, I thrive both independently and as part of a team. I regularly participate in',
      p2Highlight: 'game jams',
      p2End:
        'to push my skills, explore new ideas, and create unique gameplay experiences.',
      p3: 'Whether in solo projects or collaborative settings, my goal is to craft',
      p3Highlight: 'immersive, memorable games that connect with players',
      p3End: '.',
      stats: {
        projects: 'Projects Completed',
        experience: 'Years Experience',
        engines: 'Game Engines',
      },
      quote: {
        line1: '> System.Init(Passion);',
        line2: '> while(alive) { CreateAwesomeGames(); }',
      },
    },
    services: {
      title: 'WHAT I DO',
      subtitle:
        'From core mechanics to final polish — specialized services to bring your game to life.',
      items: {
        gameplay: {
          title: 'Gameplay Programming',
          description:
            'Core mechanics that feel tight, responsive, and satisfying. Character controllers, combat systems, movement — the heart of any great game.',
          features: [
            'Character Controllers',
            'Combat & Interaction',
            'Physics-Based Mechanics',
            'Game Feel & Juice',
          ],
        },
        ui: {
          title: 'UI Systems',
          description:
            'Clean, reactive interfaces that serve the player without getting in the way. From HUD elements to full menu systems.',
          features: [
            'HUD & In-Game UI',
            'Menu & Navigation Systems',
            'Inventory & Dialogue UI',
            'Accessibility & Feedback',
          ],
        },
        multiplayer: {
          title: 'Multiplayer & Netcode',
          description:
            'Networked gameplay that feels smooth and fair. Server-authoritative architecture, lag compensation, and replicated game state.',
          features: [
            'Server-Authoritative Movement',
            'Lag Compensation',
            'State Replication',
            'Lobby & Matchmaking',
          ],
        },
        integration: {
          title: 'Game Integration',
          description:
            'Bridging design and code — integrating assets, tools, and third-party SDKs so your team can iterate fast without friction.',
          features: [
            'Asset & Tool Integration',
            'SDK & Plugin Setup',
            'Designer-Friendly Systems',
            'Build & Pipeline Support',
          ],
        },
        ai: {
          title: 'AI & Procedural Systems',
          description:
            'Enemies that think, worlds that generate, and systems that surprise. Behavior trees, pathfinding, and procedural content generation.',
          features: [
            'Behavior Trees & FSMs',
            'Pathfinding & Navigation',
            'Procedural Generation',
            'Dynamic Difficulty',
          ],
        },
        polish: {
          title: 'Game Feel & Polish',
          description:
            'The invisible layer that makes everything feel alive — screen shake, hit-stop, particle feedback, audio cues, and the micro-details players feel but never notice.',
          features: [
            'Screen Shake & Camera FX',
            'Hit-Stop & Timing',
            'VFX & Particle Feedback',
            'Audio Integration',
          ],
        },
        more: {
          title: 'And Much More...',
          description:
            "Every game is different, and so are its challenges. If you have a specific need that isn't listed here, chances are I can help — or I'll find a way.",
          features: [
            'Custom Requests Welcome',
            'Rapid Prototyping',
            'Tech Consulting',
            'Anything In Between',
          ],
        },
      },
      andMore: 'and more...',
    },
    skills: {
      title: 'TECH STACK',
      core: 'Core Competencies',
      tools: 'Tools & Methodologies',
      growing: {
        title: 'Always Growing',
        description:
          "Game development never stands still — and neither do I. I'm constantly pushing my skills forward, exploring new techniques, and staying sharp across gameplay, systems, and tooling.",
      },
    },
    projects: {
      title: 'FEATURED WORK',
      subtitle:
        'A selection of projects highlighting my technical capabilities in game development.',
      portfolio: 'Portfolio',
      github: 'GitHub',
      demo: 'Demo',
      code: 'Code',
      letsTalk: "Let's Talk",
    },
    clients: {
      title: 'TRUSTED BY',
      subtitle: "Studios and teams I've had the pleasure of working with.",
    },
    contact: {
      title: "LET'S WARP REALITY",
      description:
        "Have a game idea that needs technical expertise? Looking for a freelance programmer to join your team? Let's discuss how I can help bring your vision to life.",
      email: 'Email',
      location: 'Location',
      locationValue: 'Toulouse, France / Remote',
      form: {
        name: 'Name',
        namePlaceholder: 'John Doe',
        email: 'Email',
        emailPlaceholder: 'john@example.com',
        subject: 'Subject',
        subjects: {
          general: 'General Inquiry',
          freelance: 'Freelance Project',
          job: 'Job Opportunity',
          other: 'Other',
        },
        message: 'Message',
        messagePlaceholder: 'Tell me about your project...',
        send: 'Send Message',
        sending: 'Sending...',
        successTitle: 'Message sent!',
        successDescription:
          "Thank you for reaching out. I'll get back to you as soon as possible.",
        errorTitle: 'Oops, something went wrong.',
        errorDescription:
          'Please try again or contact me directly at julien.machado@warpwork.fr',
        sendAnother: 'Send another message',
      },
      footer: '© {year} WarpWork. All rights reserved.',
    },
  },
  fr: {
    nav: {
      about: 'À propos',
      services: 'Services',
      skills: 'Compétences',
      projects: 'Projets',
      clients: 'Clients',
      hireMe: 'Me recruter',
    },
    hero: {
      available: 'DISPONIBLE EN FREELANCE',
      titleLine1: 'PROGRAMMEUR',
      titleLine2: 'GAMEPLAY',
      subtitle: 'Création de mécaniques de jeu immersives qui',
      subtitleHighlight: 'défient la réalité',
      description:
        'Programmeur gameplay freelance spécialisé dans le game feel, la conception de systèmes et la concrétisation de votre vision — du prototype au produit fini.',
      viewWork: 'Voir mes travaux',
      getInTouch: 'Me contacter',
    },
    about: {
      title: 'QUI SUIS-JE',
      p1: "Bonjour, je suis un programmeur gameplay français titulaire d'un Master en développement de jeux vidéo, apportant une base solide dans la création d'expériences engageantes et interactives.",
      p2: "Passionné par les jeux vidéo et aimant les défis, je m'épanouis aussi bien en autonomie qu'en équipe. Je participe régulièrement à des",
      p2Highlight: 'game jams',
      p2End:
        'pour repousser mes limites, explorer de nouvelles idées et créer des expériences de jeu uniques.',
      p3: 'Que ce soit pour des projets solo ou collaboratifs, mon objectif est de créer des',
      p3Highlight:
        'jeux immersifs et mémorables qui connectent avec les joueurs',
      p3End: '.',
      stats: {
        projects: 'Projets terminés',
        experience: "Années d'expérience",
        engines: 'Moteurs de jeu',
      },
      quote: {
        line1: '> System.Init(Passion);',
        line2: '> while(alive) { CreateAwesomeGames(); }',
      },
    },
    services: {
      title: 'CE QUE JE FAIS',
      subtitle:
        'Des mécaniques de base aux finitions — des services spécialisés pour donner vie à votre jeu.',
      items: {
        gameplay: {
          title: 'Programmation Gameplay',
          description:
            'Des mécaniques centrales précises, réactives et satisfaisantes. Contrôleurs de personnages, systèmes de combat, mouvements — le cœur de tout grand jeu.',
          features: [
            'Contrôleurs de personnages',
            'Combat & Interaction',
            'Mécaniques basées sur la physique',
            'Game Feel & Juice',
          ],
        },
        ui: {
          title: 'Systèmes UI',
          description:
            'Des interfaces propres et réactives qui servent le joueur sans le gêner. Des éléments HUD aux systèmes de menus complets.',
          features: [
            'HUD & UI en jeu',
            'Systèmes de menus & Navigation',
            'Inventaire & UI de dialogue',
            'Accessibilité & Feedback',
          ],
        },
        multiplayer: {
          title: 'Multijoueur & Netcode',
          description:
            "Un gameplay en réseau fluide et équitable. Architecture autoritaire serveur, compensation de lag et réplication de l'état du jeu.",
          features: [
            'Mouvement autoritaire serveur',
            'Compensation de lag',
            "Réplication d'état",
            'Lobby & Matchmaking',
          ],
        },
        integration: {
          title: 'Intégration de jeu',
          description:
            "Le pont entre design et code — intégration d'assets, d'outils et de SDK tiers pour que votre équipe puisse itérer rapidement sans friction.",
          features: [
            "Intégration d'assets & outils",
            'Configuration SDK & Plugin',
            'Systèmes pour designers',
            'Support Build & Pipeline',
          ],
        },
        ai: {
          title: 'IA & Systèmes Procéduraux',
          description:
            'Des ennemis qui pensent, des mondes qui se génèrent et des systèmes qui surprennent. Arbres de comportement, pathfinding et génération procédurale.',
          features: [
            'Arbres de comportement & FSM',
            'Pathfinding & Navigation',
            'Génération procédurale',
            'Difficulté dynamique',
          ],
        },
        polish: {
          title: 'Game Feel & Polish',
          description:
            "La couche invisible qui rend tout vivant — secousses d'écran, hit-stop, feedback de particules, signaux audio et les micro-détails que les joueurs ressentent sans remarquer.",
          features: [
            'Screen Shake & FX Caméra',
            'Hit-Stop & Timing',
            'VFX & Feedback Particules',
            'Intégration Audio',
          ],
        },
        more: {
          title: 'Et bien plus...',
          description:
            "Chaque jeu est différent, tout comme ses défis. Si vous avez un besoin spécifique qui n'est pas listé ici, je peux probablement aider — ou je trouverai un moyen.",
          features: [
            'Demandes personnalisées bienvenues',
            'Prototypage rapide',
            'Consulting technique',
            'Tout le reste',
          ],
        },
      },
      andMore: 'et plus...',
    },
    skills: {
      title: 'STACK TECHNIQUE',
      core: 'Compétences Clés',
      tools: 'Outils & Méthodologies',
      growing: {
        title: 'Toujours en apprentissage',
        description:
          "Le développement de jeux ne s'arrête jamais — et moi non plus. Je pousse constamment mes compétences, explore de nouvelles techniques et reste affûté sur le gameplay, les systèmes et les outils.",
      },
    },
    projects: {
      title: 'TRAVAUX EN VEDETTE',
      subtitle:
        'Une sélection de projets mettant en valeur mes capacités techniques en développement de jeux.',
      portfolio: 'Portfolio',
      github: 'GitHub',
      demo: 'Démo',
      code: 'Code',
      letsTalk: 'Discutons-en',
    },
    clients: {
      title: 'ILS ME FONT CONFIANCE',
      subtitle:
        "Studios et équipes avec lesquels j'ai eu le plaisir de travailler.",
    },
    contact: {
      title: 'DÉFORMONS LA RÉALITÉ',
      description:
        'Vous avez une idée de jeu qui nécessite une expertise technique ? Vous cherchez un programmeur freelance pour rejoindre votre équipe ? Discutons de la façon dont je peux aider à donner vie à votre vision.',
      email: 'Email',
      location: 'Localisation',
      locationValue: 'Toulouse, France / Remote',
      form: {
        name: 'Nom',
        namePlaceholder: 'Jean Dupont',
        email: 'Email',
        emailPlaceholder: 'jean@exemple.com',
        subject: 'Sujet',
        subjects: {
          general: 'Question générale',
          freelance: 'Projet Freelance',
          job: "Opportunité d'emploi",
          other: 'Autre',
        },
        message: 'Message',
        messagePlaceholder: 'Parlez-moi de votre projet...',
        send: 'Envoyer le message',
        sending: 'Envoi en cours...',
        successTitle: 'Message envoyé !',
        successDescription:
          "Merci de m'avoir contacté. Je vous répondrai dès que possible.",
        errorTitle: 'Oups, une erreur est survenue.',
        errorDescription:
          'Veuillez réessayer ou me contacter directement à julien.machado@warpwork.fr',
        sendAnother: 'Envoyer un autre message',
      },
      footer: '© {year} WarpWork. Tous droits réservés.',
    },
  },
}
